/**
 * Get the appropriate 'yesterday' date based on the current time
 * If current time is before 00:30, it returns the day before yesterday
 * Otherwise, it returns yesterday's date
 *
 * @returns {string} Formatted date string in DD/MM/YY format
 */
export function getLastUpdatedDate() {
  const now = new Date();
  const currentHour = now.getHours();
  const currentMinute = now.getMinutes();

  // Create a date object for the target date
  const targetDate = new Date(now);

  // If current time is before 00:30, go back 2 days, otherwise go back 1 day
  if (currentHour === 0 && currentMinute < 30) {
    targetDate.setDate(now.getDate() - 2);
  } else {
    targetDate.setDate(now.getDate() - 1);
  }

  // Format as DD/MM/YY
  const day = String(targetDate.getDate()).padStart(2, "0");
  const month = String(targetDate.getMonth() + 1).padStart(2, "0");
  const year = targetDate.getFullYear().toString().slice(-2);

  return `${day}/${month}/${year}`;
}
